/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { Header, LoneIconButton, Text } from '@blend/enterprise-components';

const styles = StyleSheet.create({
  headerBar: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerText: {
    marginRight: 24,
    overflowWrap: 'anywhere',
  },
  modalContent: {
    maxHeight: 950,
    overflow: 'auto',
    padding: 32,
  },
  spacer: {
    marginBottom: 8,
  },
  subHeaderText: {
    marginBottom: 24,
  },
});

export namespace ModalContent {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    headerText: string;
    subHeaderText?: string;
    handleClose?: () => void;
  }
}

export const ModalContent: React.FC<ModalContent.Props> = ({
  headerText,
  children,
  subHeaderText,
  handleClose,
  ...htmlProps
}) => {
  return (
    <div {...htmlProps} className={css(styles.modalContent)} data-it="ModalContent">
      <div className={css(styles.headerBar, styles.spacer)}>
        <div className={css(styles.headerText)}>
          <Header data-it="ModalContent-Header" size={4}>
            {headerText}
          </Header>
        </div>
        {handleClose && (
          <LoneIconButton
            icon="clear"
            data-it="ModalContent-Close"
            noBorder
            noHover
            onClick={handleClose}
            theme="tertiary"
          />
        )}
      </div>
      {subHeaderText && (
        <div data-it="ModalContent-SubHeader" className={css(styles.subHeaderText)}>
          <Text>{subHeaderText}</Text>
        </div>
      )}
      {children}
    </div>
  );
};
